/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarDto } from '../models';
// @ts-ignore
import type { CarIdDto } from '../models';
// @ts-ignore
import type { CarSearchRequestDto } from '../models';
// @ts-ignore
import type { CarSearchResponseDto } from '../models';
// @ts-ignore
import type { CreateCarRequestDto } from '../models';
// @ts-ignore
import type { UpdateCarRequestDto } from '../models';
/**
 * RestCarsApi - axios parameter creator
 */
export const RestCarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCarRequestDto} createCarRequestDto Create car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCar: async (createCarRequestDto: CreateCarRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCarRequestDto' is not null or undefined
            assertParamExists('createCar', 'createCarRequestDto', createCarRequestDto)
            const localVarPath = `/api/cars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCarRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCar: async (carId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('getCar', 'carId', carId)
            const localVarPath = `/api/cars/{carId}`
                .replace('{carId}', encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of cars
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarSearchRequestDto} carSearchRequestDto Car search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCars: async (page: number, pageSize: number, carSearchRequestDto: CarSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchCars', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchCars', 'pageSize', pageSize)
            // verify required parameter 'carSearchRequestDto' is not null or undefined
            assertParamExists('searchCars', 'carSearchRequestDto', carSearchRequestDto)
            const localVarPath = `/api/cars/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} carId 
         * @param {UpdateCarRequestDto} updateCarRequestDto Update business car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCar: async (carId: number, updateCarRequestDto: UpdateCarRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('updateCar', 'carId', carId)
            // verify required parameter 'updateCarRequestDto' is not null or undefined
            assertParamExists('updateCar', 'updateCarRequestDto', updateCarRequestDto)
            const localVarPath = `/api/cars/{carId}`
                .replace('{carId}', encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCarRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCarsApi - functional programming interface
 */
export const RestCarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCarsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCarRequestDto} createCarRequestDto Create car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCar(createCarRequestDto: CreateCarRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCar(createCarRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarsApi.createCar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCar(carId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCar(carId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarsApi.getCar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of cars
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarSearchRequestDto} carSearchRequestDto Car search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCars(page: number, pageSize: number, carSearchRequestDto: CarSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCars(page, pageSize, carSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarsApi.searchCars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} carId 
         * @param {UpdateCarRequestDto} updateCarRequestDto Update business car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCar(carId: number, updateCarRequestDto: UpdateCarRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCar(carId, updateCarRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarsApi.updateCar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCarsApi - factory interface
 */
export const RestCarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCarsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCarRequestDto} createCarRequestDto Create car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCar(createCarRequestDto: CreateCarRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CarIdDto> {
            return localVarFp.createCar(createCarRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCar(carId: number, options?: RawAxiosRequestConfig): AxiosPromise<CarDto> {
            return localVarFp.getCar(carId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of cars
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarSearchRequestDto} carSearchRequestDto Car search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCars(page: number, pageSize: number, carSearchRequestDto: CarSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CarSearchResponseDto> {
            return localVarFp.searchCars(page, pageSize, carSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} carId 
         * @param {UpdateCarRequestDto} updateCarRequestDto Update business car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCar(carId: number, updateCarRequestDto: UpdateCarRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCar(carId, updateCarRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCarsApi - interface
 */
export interface RestCarsApiInterface {
    /**
     * 
     * @param {CreateCarRequestDto} createCarRequestDto Create car
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCar(createCarRequestDto: CreateCarRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CarIdDto>;

    /**
     * 
     * @param {number} carId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCar(carId: number, options?: RawAxiosRequestConfig): AxiosPromise<CarDto>;

    /**
     * 
     * @summary Get list of cars
     * @param {number} page 
     * @param {number} pageSize 
     * @param {CarSearchRequestDto} carSearchRequestDto Car search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCars(page: number, pageSize: number, carSearchRequestDto: CarSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CarSearchResponseDto>;

    /**
     * 
     * @param {number} carId 
     * @param {UpdateCarRequestDto} updateCarRequestDto Update business car
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCar(carId: number, updateCarRequestDto: UpdateCarRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestCarsApi - object-oriented interface
 */
export class RestCarsApi extends BaseAPI implements RestCarsApiInterface {
    /**
     * 
     * @param {CreateCarRequestDto} createCarRequestDto Create car
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCar(createCarRequestDto: CreateCarRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarsApiFp(this.configuration).createCar(createCarRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} carId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCar(carId: number, options?: RawAxiosRequestConfig) {
        return RestCarsApiFp(this.configuration).getCar(carId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of cars
     * @param {number} page 
     * @param {number} pageSize 
     * @param {CarSearchRequestDto} carSearchRequestDto Car search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCars(page: number, pageSize: number, carSearchRequestDto: CarSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarsApiFp(this.configuration).searchCars(page, pageSize, carSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} carId 
     * @param {UpdateCarRequestDto} updateCarRequestDto Update business car
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCar(carId: number, updateCarRequestDto: UpdateCarRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarsApiFp(this.configuration).updateCar(carId, updateCarRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

